module.exports = __webpack_public_path__ + "img/brise-vues.dbdca348.jpg";